<modal>
  <modal-header>
    <h2>{{ !isComplete ? submissionModalHeaderSubmittingText : submissionModalHeaderSubmittedText }}</h2>
  </modal-header>
  <modal-content>
    <div class="submission-status">
      <div class="status-text">
        <div *ngIf="!isComplete && !timedOut">
          <app-loading-indicator [position]="'relative'"></app-loading-indicator>
          {{ submissionInProgressText }}
        </div>
        <div *ngIf="isComplete">
          <div [innerHTML]="submissionCompleteText"></div>
          <spark-ces-survey
            *ngIf="opportunityType | smsfOrCommercial"
            [opportunityId]="opportunityId"></spark-ces-survey>
        </div>
        <div *ngIf="timedOut">
          {{ submissionStatusTimedOutText }}
        </div>
      </div>
    </div>
  </modal-content>
  <modal-footer *ngIf="isComplete || timedOut">
    <lds-button appearance="action" *ngIf="isComplete && !timedOut" (click)="onRedirect()">
      {{ submissionCompleteButtonText }}
    </lds-button>
    <lds-button appearance="secondary" 
      *ngIf="timedOut"
      (click)="bsModalRef.hide()">
      Close
    </lds-button>
  </modal-footer>
</modal>